import React from 'react';

import './SmsTooltip.scss';

export default class SmsTooltip extends React.Component {
    constructor(props) {
        super(props);
        this.state = { show: false };
    }

    handleShow = () => {
        const { show } = this.state;
        this.setState({ show: !show });
    };

    render() {
        const { children, text, cssClass, isHover } = this.props;
        const { show } = this.state;

        return (
            <span
                className={`sms-tooltip ${isHover ? 'hover' : ''} ${show ? 'show' : ''} ${
                    cssClass ? cssClass : ''
                }`}
                onClick={this.handleShow}>
                {children}
                <span className="sms-tooltip-text-wrapper">{text}</span>
            </span>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/pages/ebon/sms/tooltip/SmsTooltip.js